module.exports = __webpack_public_path__ + "static/apaa-2a344e3928fa5ec3a8ecd251e327b003.svg";